import { Component, OnInit, Inject, Input } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from "../../variables/translate-service";
import { Observable } from 'rxjs';
import { GlobalFunctionService } from "../../services/global-function.service";
import { InputBoxData, InputBoxEmit } from "../../../common/lib/InputBoxData";
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'sen-app-input-box',
  templateUrl: './input-box.component.html',
  styleUrls: ['./input-box.component.scss']
})

export class InputBoxComponent implements OnInit {
  form: FormGroup;
  existingName: boolean = false;
  constructor(public translate: TranslateService,
    private formBuilder: FormBuilder,
    public dialogRef: MatDialogRef<InputBoxComponent>,
    @Inject(MAT_DIALOG_DATA) public data: InputBoxData,
    public globalFunction: GlobalFunctionService) {
    this.form = this.formBuilder.group({
      name: new FormControl(null, Validators.required)
    })
  }

  ngOnInit(): void {
  }

  copyPlanExistName(event: Event) {
    this.existingName = this.globalFunction.checkRoofPlayNameExist((event.target as HTMLInputElement).value.toLowerCase());
  }

  checkPlanCopy() {
    return this.data.label == `${this.translate.getLng('PLAN')} ${this.translate.getLng('NAME')}`;
  }

  checkForDisable() {
    this.form.markAllAsTouched();
    if (this.checkPlanCopy()) {
      if (!this.form.get('name')?.value || this.existingName) return;
    }
    this.closeDialogue(true);
  }

  closeDialogue(action: boolean) {
    this.dialogRef.close(new InputBoxEmit(action, this.form.get('name')?.value));
  }

}